import React from 'react';
import PrintPrice from "../general/PrintPrice";
export const GeneralTablePriceColumn = cell => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PrintPrice, {
    price: cell
  }));
};